export { default as LifestylesIndexPageCategoriesNavItem } from './LifestylesIndexPageCategoriesNavItem';
